export default __webpack_public_path__ + "static/media/u-logo-gray.2578694f.svg";